/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServizioMensaStudenteSospensione { 
    data?: string;
    operatore?: string;
    automatica?: boolean;
    motivo?: string;
}

